export * from "./Logger";
export * from "./DeepMerge";
export * from "./PadString";
export * from "./SplitTime";
export * from "./ParseTime";
export * from "./CustomTags";
export * from "./DateFormat";
export * from "./IsFunction";
export * from "./ErrorLogger";
export * from "./ArrayHelper";
export * from "./ReturnColor";
export * from "./AjaxService";
export * from "./PrecisionMath";
export * from "./ActionFromCMS";
export * from "./ProcessColorDiff";
export * from "./DynamicScriptLoad";
export * from "./Branches";
export * from "./FakeIntersectionObserver";
export * from "./GetIntersectionObserverConstructor";
export * from "./GetElementOrBody";
import CookiesInternal from "js-cookie";
export var Cookies = CookiesInternal;
// make sure we have all the needed custom tags registered on the page
import { registerCustomTagsFromTagsCollection, customTags } from "./CustomTags";
registerCustomTagsFromTagsCollection(customTags);
export var mocks = {};
if (process.env.NODE_ENV === "development") {
    mocks = require("./mocks");
}
//# sourceMappingURL=index.js.map